import { Orientation } from "../../../interfaces";

export default {
  //Agile Coaches
  0x00: {
    //Teambild
    thumbnail: '/assets/images/thumbnails/AgileCoaches/Coaches.jpg',
        url: '/assets/images/thumbnails/AgileCoaches/Coaches.jpg',
        orientation: Orientation.NORTH
  },
  //A-Team
  0x01: {
    //Teambild
    thumbnail: '/assets/images/thumbnails/ATeam/FeelGoodManagement.jpg',
        url: '/assets/images/thumbnails/ATeam/FeelGoodManagement.jpg',
        orientation: Orientation.NORTH
  },
  // Mac n Cheese
  0x02: {
    //Teambild
    thumbnail: '/assets/images/thumbnails/MacCheese/MacCheese.jpg',
        url: '/assets/images/thumbnails/MacCheese/MacCheese.jpg',
        orientation: Orientation.NORTH
  },
  //Rochen
  0x03: {
    //Teambild
    thumbnail: '/assets/images/thumbnails/Rochen/teamRochen.jpg',
        url: '/assets/images/thumbnails/Rochen/teamRochen.jpg',
        orientation: Orientation.NORTH
  },
  0x04: {
    //Work: Audience Configurator
    thumbnail: '/assets/images/thumbnails/Rochen/rochen_audienceConfigurator.jpg',
        url: '/assets/images/thumbnails/Rochen/rochen_audienceConfigurator.jpg',
        orientation: Orientation.NORTH
  },
  0x05: {
    //Work: Change Radar
    thumbnail: '/assets/images/thumbnails/Rochen/rochen_ChangeRadar.jpg',
        url: '/assets/images/thumbnails/Rochen/rochen_ChangeRadar.jpg',
        orientation: Orientation.NORTH
  },
  0x06: {
    //Work: VR Headquarter
    thumbnail: '/assets/images/thumbnails/Rochen/rochen_VRHQ.jpg',
        url: '/assets/images/thumbnails/Rochen/rochen_VRHQ.jpg',
        orientation: Orientation.EAST
  },
  //Sheldons
  0x07: {
    //Teambild
    thumbnail: '/assets/images/thumbnails/Sheldons/Sheldons.jpg',
        url: '/assets/images/thumbnails/Sheldons/Sheldons.jpg',
        orientation: Orientation.NORTH
  },
  0x08: {
    //Work: AS Gateway
    thumbnail: '/assets/images/thumbnails/Sheldons/Sheldons_asGateway.jpg',
        url: '/assets/images/thumbnails/Sheldons/Sheldons_asGateway.jpg',
        orientation: Orientation.NORTH
  },
  0x09: {
    //Work: I Beamer
    thumbnail: '/assets/images/thumbnails/Sheldons/Sheldons_iBeamer.jpg',
        url: '/assets/images/thumbnails/Sheldons/Sheldons_iBeamer.jpg',
        orientation: Orientation.EAST
  },
  0x0a: {
    //Work: Op in Layer
    thumbnail: '/assets/images/thumbnails/Sheldons/Sheldons_OpInLayer.jpg',
        url: '/assets/images/thumbnails/Sheldons/Sheldons_OpInLayer.jpg',
        orientation: Orientation.EAST
  },
  // Tailors
  0x0b: {
    //Teambild
    thumbnail: '/assets/images/thumbnails/Tailors/Tailors.jpg',
        url: '/assets/images/thumbnails/Tailors/Tailors.jpg',
        orientation: Orientation.NORTH
  },
  0x0c: {
    //Work: content exchange plattform
    thumbnail: '/assets/images/thumbnails/Tailors/Tailors_contentExchangePlatform.jpg',
        url: '/assets/images/thumbnails/Tailors/Tailors_contentExchangePlatform.jpg',
        orientation: Orientation.EAST
  },
  0x0d: {
    //Work: newsfinder
    thumbnail: '/assets/images/thumbnails/Tailors/Tailors_newsfinder.jpg',
        url: '/assets/images/thumbnails/Tailors/Tailors_newsfinder.jpg',
        orientation: Orientation.EAST
  },
  0x0e: {
    //Work: Blacklist bell
    thumbnail: '/assets/images/thumbnails/Tailors/Tailors_blacklistBell.jpg',
        url: '/assets/images/thumbnails/Tailors/Tailors_blacklistBell.jpg',
        orientation: Orientation.EAST
  },
  //Team AI
  0x0f: {
    //Teambild
    thumbnail: '/assets/images/thumbnails/TeamAI/TeamAI.jpg',
        url: '/assets/images/thumbnails/TeamAI/TeamAI.jpg',
        orientation: Orientation.NORTH
  },
  0x10: {
    //Work: Document Classification
    thumbnail: '/assets/images/thumbnails/TeamAI/TeamAI_DocumentClassification.jpg',
        url: '/assets/images/thumbnails/TeamAI/TeamAI_DocumentClassification.jpg',
        orientation: Orientation.EAST
  },
  0x11: {
    //Work: Image Quality Assessment
    thumbnail: '/assets/images/thumbnails/TeamAI/TeamAI_ImageQualityAssessment.jpg',
        url: '/assets/images/thumbnails/TeamAI/TeamAI_ImageQualityAssessment.jpg',
        orientation: Orientation.EAST
  },
  0x12: {
    //Work: Seq2Seq
    thumbnail: '/assets/images/thumbnails/TeamAI/TeamAI_seq2seq.jpg',
        url: '/assets/images/thumbnails/TeamAI/TeamAI_seq2seq.jpg',
        orientation: Orientation.NORTH
  },
  0x13: {
    //Work: Text 2 speech
    thumbnail: '/assets/images/thumbnails/TeamAI/TeamAI_TextToSpeech.jpg',
        url: '/assets/images/thumbnails/TeamAI/TeamAI_TextToSpeech.jpg',
        orientation: Orientation.EAST
  },
  //Team UX
  0x14: {
    //Teambild
    thumbnail: '/assets/images/thumbnails/TeamUX/TeamUX.jpg',
        url: '/assets/images/thumbnails/TeamUX/TeamUX.jpg',
        orientation: Orientation.NORTH
  },
  0x15: {
    //Work: Design Workshop
    thumbnail: '/assets/images/thumbnails/TeamUX/TeamUX_DesignWorkshop.jpg',
        url: '/assets/images/thumbnails/TeamUX/TeamUX_DesignWorkshop.jpg',
        orientation: Orientation.NORTH
  },
  // Team X
  0x16: {
    //Teambild:
    thumbnail: '/assets/images/thumbnails/TeamX/TeamX.jpg',
        url: '/assets/images/thumbnails/TeamX/TeamX.jpg',
        orientation: Orientation.NORTH
  },
  0x17: {
    // Work: 360 Content Viewer
    thumbnail: '/assets/images/thumbnails/TeamX/TeamX_360ContentViewer.jpg',
        url: '/assets/images/bigImages/TeamX/TeamX_360ContentViewer.jpg',
        orientation: Orientation.NORTH
  },
  0x18: {
    // Work: Neubau after dark
    thumbnail: '/assets/images/thumbnails/TeamX/TeamX_NeubauAfterDark.jpg',
        url: '/assets/images/bigImages/TeamX/TeamX_NeubauAfterDark.jpg',
        orientation: Orientation.NORTH
  },
}